const UUID = "[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}";
const PROFILE_ROUTE = new RegExp(
  `^#aluno/(${UUID})/(overview|chats|protocols|exams|nutrition|training|body|progress|report)(?:/(${UUID}))?$`,
  "i",
);

export function normalizeLegacyHash(hash: string): string | null {
  if (hash === "" || hash === "#") return "#/";
  if (hash === "#chat") return "#/chat";
  if (hash === "#alunos") return "#/alunos";
  if (hash === "#meu-perfil") return "#/meu-perfil";
  const match = hash.match(PROFILE_ROUTE);
  if (match?.[1] && match[2]) {
    const suffix = match[3] === undefined ? "" : `/${match[3]}`;
    return `#/aluno/${match[1]}/${match[2]}${suffix}`;
  }
  return null;
}

export function legacyAppHref(hash: string): string {
  const configured = import.meta.env.VITE_LEGACY_APP_URL as unknown;
  const base =
    typeof configured === "string" && configured.length > 0
      ? configured
      : "../frontend-legacy/app.html";
  return `${base}?bridge=react-phase2${hash}`;
}
